import moment from 'moment/moment';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

type DateTimeProps = PropsWithClassName<{
  dateTime?: string | null;
}>;

export function DateTime({ dateTime, className }: DateTimeProps) {
  if (!dateTime) {
    return null;
  }

  const parsed = moment.utc(dateTime, 'YYYY-MM-DD HH:mm:ss').local();

  return (
    <time dateTime={dateTime} className={cn('flex flex-col', className)}>
      <span>{parsed.format('DD/MM/YYYY')}</span>
      <span className="text-sm text-gray-500">{parsed.format('HH:mm')}</span>
    </time>
  );
}
